import * as React from "react";
import { forwardRef } from "react";
const SvgHint = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "transparent", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 12.8437V12.8062M9 10.9687C9 8.67375 11.25 9.735 11.25 7.44045C11.25 4.39485 6.75 4.39485 6.75 7.44045", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 9, cy: 9, r: 7, stroke: "currentColor" }));
const ForwardRef = forwardRef(SvgHint);
export { ForwardRef as ReactComponent };
